export default __webpack_public_path__ + "static/media/Icon_Arrow-down.615426ef.svg";